import api from "./api";
import axios from "axios";
import { toast } from "react-toastify";
const captchaVerify = async (captchaValue) => {
  try {
    const response = await api.post("/registration/verify-captcha/", {
      captcha: captchaValue,
    });
    return response.data.success;
  } catch (ex) {
    console.log(ex);
    return false;
  }
};

const completeOnboarding = async (data) => {
  try {
    const response = await api
      .post("registration/complete-onboarding/", data)
      .then((res) => res.data);
    if (response.success) return true;
    else throw new Error(response.response);
  } catch (ex) {
    toast.error(ex.message);
    console.log(ex);
    return false;
  }
};
const OnboardingService = {
  captchaVerify,
  completeOnboarding,
};
export default OnboardingService;
